export default {
    methods: {
        sendLink() {
            this.loading = true;
            window.axios.post('/email/resend')
                .then(() => {
                    this.showSentMessage = true;
                    this.loading = false;
                })
                .catch(() => {
                    this.$notify({
                        message: this.$t('emails.verify.fail_link_another_send'),
                        type: 'danger',
                    });
                    this.loading = false;
                });
        },
    },
};
